__turbopack_context__.v({
  "afterFooter": "Footer-module__rnk_JG__afterFooter",
  "description": "Footer-module__rnk_JG__description",
  "footer": "Footer-module__rnk_JG__footer",
  "groups": "Footer-module__rnk_JG__groups",
  "inner": "Footer-module__rnk_JG__inner",
  "link": "Footer-module__rnk_JG__link",
  "logo": "Footer-module__rnk_JG__logo",
  "social": "Footer-module__rnk_JG__social",
  "title": "Footer-module__rnk_JG__title",
  "wrapper": "Footer-module__rnk_JG__wrapper",
});
